import { toast } from "react-toastify";

function exceptionHandler(error, callback) {
  console.log(error);
  callback && callback();

  if (!callback) {
    toast("An error occured while processing the request.", {
      autoClose: 3000,
      type: toast.TYPE.ERROR,
      hideProgressBar: false,
    });
  }
}

export default exceptionHandler;